import { Box, Grid, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

export const TermsOfUse = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        flexDirection: 'column',
        width: '100%',
        backgroundColor: 'rgb(241,241,241)',
      }}
    >
      <Stack
        sx={{ alignItems: 'center', paddingTop: '2em', paddingBottom: '1em' }}
      >
        <Grid
          container
          sx={{
            marginBottom: '20px',
            maxWidth: '1200px',
            alignItems: 'center',
          }}
        >
          <h2 className="cardTitle">{t('TermsOfUse')}</h2>
          <Typography>
            <Trans t={t}>TermsOfUseContent</Trans>
          </Typography>
        </Grid>
      </Stack>
    </Box>
  );
};
